const check = {
  name: 'findPwdCheck',
  path: 'check',
  props: true,
  component: resolve => require(['../../../../pages/custom/find-pwd/check'], resolve)
}

export default check
